/* Menu previews share requests, retain Shopify currency formatting, and retry failures. */
(function(root) {
  'use strict';
  function createLoader(fetchHTML, parseHTML, origin) {
    var pending = new Map();
    return function load(href) {
      var url = new URL(href, origin);
      if (url.origin !== origin || !/\/collections\/[^/]+/.test(url.pathname)) return Promise.resolve([]);
      url.search = '';
      url.hash = '';
      url.searchParams.set('section_id', 'avora-menu-products');
      var key = url.href;
      if (!pending.has(key)) {
        var request = fetchHTML(key).then(parseHTML).catch(function(error) {
          pending.delete(key);
          throw error;
        });
        pending.set(key, request);
      }
      return pending.get(key);
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createLoader: createLoader };
  if (!root.document) return;
  root.AvoraMenuProducts = { load: createLoader(function(url) {
    var controller = new AbortController();
    var timer = setTimeout(function() { controller.abort(); }, 8000);
    return fetch(url, { signal: controller.signal, credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) throw new Error(window.AvoraI18n.text('Menu preview unavailable'));
      return response.text();
    }).finally(function() { clearTimeout(timer); });
  }, function(html) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-avora-menu-products]');
    var products = node && JSON.parse(node.textContent);
    if (!Array.isArray(products)) throw new Error('Invalid menu preview');
    return products;
  }, root.location.origin) };
})(typeof window === 'undefined' ? globalThis : window);
